<div class="admin-container">
  <div class="page-top-banner">
    <div class="title">Administrateurs clients</div>
    <div class="action-zone">
      <button mat-icon-button class="accent-button" (click)="onCreate()">
        <mat-icon>add</mat-icon>
        <span class="text-button">Créer un administrateur</span>
      </button>
    </div>
  </div>

  @if(dataSource){
  <div class="table-container">
    <form [formGroup]="filtersForm">
      <table mat-table [dataSource]="dataSource" class="default-table">

        <ng-container matColumnDef="prenom">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>Prénom</span>
            <div class="small">
              <mat-form-field appearance="outline">
                <input matInput formControlName="prenom" (keyup)="applyFilters()" autocomplete="off" />
                <button mat-icon-button matSuffix matTooltip="Réinitialiser le filtre"
                  (click)="resetColumnFilter('prenom')" type="button">
                  <mat-icon>clear</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">{{ getProperty(element, 'Firstname') }}</td>
        </ng-container>

        <ng-container matColumnDef="nom">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>Nom</span>
            <div class="small">
              <mat-form-field appearance="outline">
                <input matInput formControlName="nom" (keyup)="applyFilters()" autocomplete="off" />
                <button mat-icon-button matSuffix matTooltip="Réinitialiser le filtre"
                  (click)="resetColumnFilter('nom')" type="button">
                  <mat-icon>clear</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">{{ getProperty(element, 'Lastname') }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>Email</span>
            <div class="small">
              <mat-form-field appearance="outline">
                <input matInput formControlName="email" (keyup)="applyFilters()" autocomplete="off" />
                <button mat-icon-button matSuffix matTooltip="Réinitialiser le filtre"
                  (click)="resetColumnFilter('email')" type="button">
                  <mat-icon>clear</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">{{ getProperty(element, 'Email') }}</td>
        </ng-container>

        <ng-container matColumnDef="telephone">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>Téléphone</span>
            <div class="small">
              <mat-form-field appearance="outline">
                <input matInput formControlName="telephone" (keyup)="applyFilters()" autocomplete="off" />
                <button mat-icon-button matSuffix matTooltip="Réinitialiser le filtre"
                  (click)="resetColumnFilter('telephone')" type="button">
                  <mat-icon>clear</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">{{ getProperty(element, 'Phone') }}</td>
        </ng-container>

        <ng-container matColumnDef="fonction">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>Fonction</span>
            <div class="small">
              <mat-form-field appearance="outline">
                <input matInput formControlName="fonction" (keyup)="applyFilters()" autocomplete="off" />
                <button mat-icon-button matSuffix matTooltip="Réinitialiser le filtre"
                  (click)="resetColumnFilter('fonction')" type="button">
                  <mat-icon>clear</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">{{ getProperty(element, 'Function') }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-center">
            Actions
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="actions-img">
              <button mat-icon-button color="primary" (click)="onEdit(element)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="onDelete(element)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      </table>
    </form>

    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  </div>
  }
</div>